import { AppPath } from 'appConstants';

// The PE and Music sites send users to the sign-in page with an auto-login token in the address. It
// is taken out of the address as soon as the app loads, before the router reads it, because
// redirects carry the query string from page to page. Left there, it followed the user around and,
// after they signed out, the sign-in page found it and signed them straight back in.
let urlToken: string | null = null;

const params = new URLSearchParams(window.location.search);
const path = window.location.pathname.toLowerCase().replace(/\/$/, '');

if (path === AppPath.SIGN_IN && params.has('token')) {
  urlToken = params.get('token');
  params.delete('token');
  const query = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`
  );
}

/** The token the app was opened with, handed out once so it signs in only once. */
export const takeAutoLoginToken = (): string | null => {
  const token = urlToken;
  urlToken = null;
  return token;
};
